class ToggleContent {
  static init() {
    document.addEventListener('DOMContentLoaded', () => new ToggleContent());
  }

  constructor() {
    this.activeClass = 'is-active';
    this.setup();
  }

  setup() {
    document.querySelectorAll('[data-toggle-content]').forEach((content) => {
      content.classList.remove(this.activeClass);
    });

    document.querySelectorAll('[data-toggle-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this));
      const contentId = trigger.getAttribute('data-toggle-trigger');
      const content = document.querySelector(`[data-toggle-content="${contentId}"]`);

      if (content) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', contentId);
        content.setAttribute('id', contentId);
      }
    });
  }

  handleTriggerClick(event) {
    event.preventDefault();
    const trigger = event.currentTarget;
    const contentId = trigger.getAttribute('data-toggle-trigger');
    const content = document.querySelector(`[data-toggle-content="${contentId}"]`);

    if (!content) return;

    content.classList.toggle(this.activeClass);
    trigger.classList.toggle(this.activeClass);
    trigger.setAttribute('aria-expanded', content.classList.contains(this.activeClass));
  }
}

ToggleContent.init();
